// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"748432fad58bd7e0ac7a","9249":"37b59281381e0e163bb8"}[chunkId] + ".chunk.js";
};